<form class="filter-row" [formGroup]="providerGroupProcessorsForm">
  <div class="row mb-3">
    <div class="col-6">
      <div class="row align-items-center pr-2">
        <div class="input-label col-4">PM Identifier</div>
        <div class="col-8">
          <input
            type="text"
            placeholder="Enter PM Identifier"
            class="input"
            formControlName="pMIdentifier"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6 pr-3">
      <div class="d-flex align-items-center mb-3">
        <div class="standart-text title">Professional Processor</div>

        <div class="ml-auto">
          <checkbox
            formControlName="partialRedirectProfessional"
            checkedValue="Y"
            uncheckedValue="N"
          >
            Use ERA Defaults
          </checkbox>
        </div>
      </div>

      <div>
        <div class="row mb-3">
          <div class="input-label col-4">Processor ID</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter Processor ID"
              class="input"
              formControlName="processorId"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="input-label col-4">Submitter ID</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter Submitter ID"
              class="input"
              formControlName="submitterId"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="input-label col-4">App Sender Code</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter App Sender Code"
              class="input"
              formControlName="appSenderCode"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="input-label col-4">NM1 09 Identifier Code</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter NM1 09 Identifier Code"
              class="input"
              formControlName="nM109IdCode"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 pl-3">
      <div class="d-flex align-items-center mb-3">
        <div class="standart-text title">Institutional Processor</div>

        <div class="ml-auto">
          <checkbox
            formControlName="partialRedirectInstitutional"
            checkedValue="Y"
            uncheckedValue="N"
          >
            Use ERA Defaults
          </checkbox>
        </div>
      </div>

      <div>
        <div class="row align-items-center mb-3">
          <div class="input-label col-4">Processor ID</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter Processor ID"
              class="input"
              formControlName="instProcessorId"
            />
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="input-label col-4">Submitter ID</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter Submitter ID"
              class="input"
              formControlName="instSubmitterId"
            />
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="input-label col-4">App Sender Code</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter App Sender Code"
              class="input"
              formControlName="instAppSenderCode"
            />
          </div>
        </div>
        <div class="row align-items-center">
          <div class="input-label col-4">NM1 09 Identifier Code</div>
          <div class="col-8">
            <input
              type="text"
              placeholder="Enter NM1 09 Identifier Code"
              class="input"
              formControlName="instNM109IdCode"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
